<template>
  <div class="inputShell" :class="notemr ? '' : 'temr' ">
    <div class="inputBox">
      <span v-if="params.title" :class="`title ${params.field}`">{{ params.title }}</span>
      <div class="inputItem">
        <input
          class="inputContainer"
          :readonly="params.disabled"
          :placeholder="params.props.placeholder"
          :maxLength="params.props.maxLength"
          @input="changeInput"
          v-model="value"
          type="text"
        />
        <div class="error" :style="{ color: 'red' }" v-if="error && value !== ''">{{ error }}</div>
        <button
        type="button"
        slot="button"
        id="buttonStyle"
        :disabled="disabled"
        @click="sendPicCode"
      >
        {{ messageButton }}
      </button>
      </div>
    </div>
    <van-icon v-if="!params.disabled && allowClearHandler && value" @click="allowClear" class="cross" name="cross" />
    <CodePopup
      title="请输入验证码"
      @getInputPicVal="getInputPicVal"
      @define="sendcode"
      @sendPicCode="sendPicCode"
      @close="closeSend"
      :imgUrl="imgUrl"
      :value="isShowSend"
      :isShow="isShowSend"
    ></CodePopup>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { mapActions, mapState } from 'vuex';
import service from '@/request/api'; // 导入api接口
import CodePopup from './CodePopup.vue';

export default {
  name: 'MessageCode',
  data() {
    return {
      disabled: false,
      messageButton: '获取验证码',
      time: 0,
      col: '',
      value: '',
      error: '',
      imgUrl:'',
      isShowSend: false,
      inputPicValSend: '',
      codeType: '1',
    };
  },
  components: {
    CodePopup
  },
  props: ['params', 'errorMessage', 'allowClearHandler', 'form', 'notemr'],
  methods: {
    getInputPicVal(val) {
      this.inputPicValSend = val;
    },
    closeSend() {
      this.isShowSend = false;
    },
    sendPicCode() {
      console.log(1234567,this.params.phone)
      const reg = /^1[0-9]{10}$/;
      if (!this.params.phone) {
        return Toast({
          message: '手机号不能为空',
          forbidClick: true, // 背景不可点击
        });
      } if (!reg.test(this.params.phone)) {
        return Toast({
          message: '请输入正确的手机号',
          forbidClick: true, // 背景不可点击
        });
      }
      this.isShowSend = true;
      this.$api.PublicPage.getVerify({
        phone: this.params.phone,
        type: this.codeType,
      })
        .then((res) => {
          let str = '';
          if (res.success) {
            if (res.data.type === 'png') {
              str = `data:image/png;base64,${res.data.file}`;
            } else {
              str = `data:image/jpg;base64,${res.data.file}`;
            }
          }
          this.imgUrl = str;
        })
        .catch(() => { });
    },
    ...mapActions('publicPage'),
    allowClear() {
      this.value = '';
      this.allowClearHandler();
    },
    changeInput(val) {
      if (this.params.field === 'taxNo' || this.params.field === 'borrowerIdentity' || this.params.field === 'iceContactIdentity') {
        this.value = val.target.value.toUpperCase();
      } else {
        this.value = val.target.value;
      }
    },
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        // eslint-disable-next-line no-plusplus
        this.time--;
        this.messageButton = `${this.time}s后获取`;
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.messageButton = '获取验证码';
        this.disabled = false;
      }
    },
    sendcode(obj) {
      if (!obj.value) {
        return
      }
      if(!this.inputPicValSend){
        Toast({
          message: '图形验证码不能为空',
        });
      }
      this.disabled = true;
      this.$api.PublicPage.getSms({type: 3,
          method: 'getSms',phone:this.params.phone, code:this.inputPicValSend})
        .then((res) => {
          if (res.success) {
            this.isShowSend = false;
            this.time = 60;
            this.timer();
          } else {
            this.sendPicCode()
            Toast({
              message: res.returnMessage,
              forbidClick: true, // 背景不可点击
            });
            this.disabled = false;
          }

          console.log(res);
        })
        .catch((e) => {
          console.log(e);
          this.disabled = false;
        });
    },
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  watch: {
    // 如果已经实名认证了，就将姓名、身份证号输入框禁用
    'publicPage.personAuthStatus': {
      handler(n) {
        if (n) {
          this.form.dispatch({
            type: 'upDateupDisabled',
            borrowerName: true,
          });
          this.form.dispatch({
            type: 'upDateupDisabled',
            borrowerIdentity: true,
          });
        }
      },
      immediate: true,
    },
    value: {
      handler(val, oldVal) {
        if (oldVal !== val) {
          this.$emit('input', val);
        }
      },
    },
    'params.initValue': {
      handler(val) {
        if (val !== this.value) {
          this.value = val;
        }
      },
    },
    errorMessage: {
      handler(val) {
        this.error = val.message;
      },
    },
  },
};
</script>
<style scoped lang="scss">
#buttonStyle {
  margin: 0;
  padding: 0;
  color: #ff6538;
  font-size: 14px;
  background: #fff;
  border: 1px solid transparent;
  outline: none;
  position: absolute;
  top: -2px;
  right: 20px;
}
.inputContainer {
  display: inline-block;
  border: none;
  font-size: 16px;
  padding: 0;
}
>>> input:disabled {
  background: #fff;
}
.allowClear {
  font-size: 14px;
  color: #999;
}
input{
  flex: 1;
}
.inputShell {
  position: relative;
  padding: 10px 16px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.inputBox {
  background: #fff;
  flex: 1;
  display: flex;
  .inputItem {
    display: inline-block;
    position: relative;
    flex: 1;
    display: flex;
    .error {
      position: absolute;
      bottom: -11px;
    }
  }
}
.error {
  font-size: 12px;
}

.inputShell input::placeholder {
  color: #bcc2cc;
  font-size: 16px;
}

.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
.title {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #46494D;
  line-height: 21px;
  font-weight: 400;
  display: flex;
  align-items: center;
  word-wrap: break-word;
  width: 86px;
  margin-right: 16px;
}
.input_boxcross {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.cross {
  position: absolute;
  right: 16px;
  color: #9e9fa0;
}
</style>
